import {
    inject, observer,
} from 'mobx-react';
import React, {
    Component, useState,
} from 'react';
import {
    Line, defaults
} from 'react-chartjs-2';
import {IStatisticsStore, RegistrationSources} from '../../mobx-store/storeInterfaces/statisticsInterface';
import {DatePicker} from '@material-ui/pickers';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import classes from './statistics.module.scss';
import {Button} from '@material-ui/core';
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date';
import {translate} from '../../helperFunctions/translation';
import UsersChartComponent from './usersChart';


interface IProps {
    history?: any;
    statisticsStore?: IStatisticsStore;
}

const noData = {

    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
        {
            label: "No Data",
            data: [],
            fill: true,
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)"
        },

    ]

}

interface IState {
    usersData: {};
    from: MaterialUiPickersDate;
    to: MaterialUiPickersDate;
    totalRgistred: number;
    totalSportsUsers: number;
    totalMobileUsers: number;
    totalWebUsers: number;
    totalUnknownUsers: number;
}


enum ChartLabels {
    PORTAL = 'Portal Users',
    MOBILE = 'Mobile Users',
    SPORTS = 'Sports Users',
    UNKNOWN = 'Unknown Users',
}

@inject('statisticsStore')
@observer
class DetailedStatisticsScreen extends React.Component<IProps, IState> {

    // variable to determine the x-axis labels wheather it's months or days
    monthFilter: boolean = true;
    detailedStatisticsScreen = this;
    state = {
        usersData: noData,
        from: null as MaterialUiPickersDate,
        to: null as MaterialUiPickersDate,
        totalRgistred: 0,
        totalSportsUsers: 0,
        totalMobileUsers: 0,
        totalWebUsers: 0,
        totalUnknownUsers: 0,

    };

    constructor(props: IProps) {
        super(props);
    }
    changeChartState = () => {
         if (this.state.totalRgistred)
            this.setState({
                usersData: {
                    labels: this.props.statisticsStore!.usersDetailedChartLabels,
                    datasets: [
                        {
                            label: ChartLabels.MOBILE,
                            fill: false,
                            type: 'line',
                            lineTension: 0.1,
                            backgroundColor: 'rgba(75,192,192,0.4)',
                            borderColor: 'rgba(75,192,192,1)',
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: 'rgba(75,192,192,1)',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                            pointHoverBorderColor: 'rgba(220,220,220,1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: this.props.statisticsStore!.usersDetailedStatistics[RegistrationSources.mobileApp]
                        }, {
                            label: ChartLabels.PORTAL,
                            fill: false,
                            type: 'line',
                            lineTension: 0.1,
                            backgroundColor: '#FFFF00',
                            borderColor: '#FFFF00',
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: '#FFFF00',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: '#FFFF00',
                            pointHoverBorderColor: '#FFFF00',
                            hoverBackgroundColor: '#FFFF00',
                            hoverBorderColor: '#FFFF00',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: this.props.statisticsStore!.usersDetailedStatistics[RegistrationSources.webPortal]
                        }, {
                            label: ChartLabels.SPORTS,
                            fill: false,
                            type: 'line',
                            lineTension: 0.1,
                            backgroundColor: '#000000',
                            borderColor: '#000000',
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: '#000000',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: '#000000',
                            pointHoverBorderColor: '#000000',
                            hoverBackgroundColor: '#000000',
                            hoverBorderColor: '#000000',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: this.props.statisticsStore!.usersDetailedStatistics[RegistrationSources.sportsReservation]
                        }, {
                            label: ChartLabels.UNKNOWN,
                            fill: false,
                            type: 'line',
                            lineTension: 0.1,
                            backgroundColor: '#F7464A',
                            borderColor: '#F7464A',
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: '#F7464A',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: '#F7464A',
                            pointHoverBorderColor: '#F7464A',
                            hoverBackgroundColor: '#F7464A',
                            hoverBorderColor: '#F7464A',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 10,
                            data: this.props.statisticsStore!.usersDetailedStatistics[RegistrationSources.unknown]
                        }
                    ]
                },
            });
        else
            this.setState({usersData:noData})
    }

    async componentDidMount() {
        await this.props.statisticsStore!.getUsersDetailedStatistics();
        this.handleRegistraionCount();
        this.changeChartState();
        // this.changeChartState();
    }

    handleFromChanged = async (date: MaterialUiPickersDate) => {
        this.setState({
            from: date,
        });
        await this.changeChartState();

    }

    handleToChanged = async (date: MaterialUiPickersDate) => {
        console.log('data , data', date);
        this.setState({
            to: date
        });
        await this.changeChartState();

    }


    filter = async () => {

        try {


            if (!this.state.from || !this.state.to) {
                SnackBarComponent.getInstance().openSnackbar(
                    'Start date and end date are required',
                    3000,
                    'error'
                );
                return;
            }
            if(this.state.to<this.state.from){
                SnackBarComponent.getInstance().openSnackbar(
                    'Start date should be before end date',
                    3000,
                    'error'
                );
                return;
            }

            const from = `${this.state.from!.month}-${this.state.from!.day}-${this.state.from!.year}`;
            const to = `${this.state.to!.month}-${this.state.to!.day}-${this.state.to!.year}`;

            await this.props.statisticsStore!.getUsersDetailedStatistics(from, to);
            this.handleRegistraionCount();
            this.setState({usersData: noData})
            this.changeChartState();
        } catch (error) {
            console.log(error);
            SnackBarComponent.getInstance().openSnackbar(
                'Error while Filtering',
                3000,
                'error'
            );
        }
    }

    clearFilter = async () => {
        await this.props.statisticsStore!.getUsersDetailedStatistics();
        this.setState({
            usersData: noData,
            from: null,
            to: null,
            totalRgistred: 0,
            totalSportsUsers: 0,
            totalMobileUsers: 0,
            totalWebUsers: 0,
            totalUnknownUsers: 0,
        });
        this.handleRegistraionCount();
        this.changeChartState();
    }

    handleRegistraionCount = () => {
        const totalMobileUsers: number =
            this.props.statisticsStore?.usersDetailedStatistics[RegistrationSources.mobileApp].reduce((a, b) => a + b, 0) || 0;
        const totalSportsUsers: number =
            this.props.statisticsStore?.usersDetailedStatistics[RegistrationSources.sportsReservation].reduce((a, b) => a + b, 0) || 0;
        const totalWebUsers: number =
            this.props.statisticsStore?.usersDetailedStatistics[RegistrationSources.webPortal].reduce((a, b) => a + b, 0) || 0;
        const totalUnknownUsers: number =
            this.props.statisticsStore?.usersDetailedStatistics[RegistrationSources.unknown].reduce((a, b) => a + b, 0) || 0;
        this.setState({
            totalRgistred: totalMobileUsers + totalSportsUsers + totalWebUsers + totalUnknownUsers,
            totalSportsUsers,
            totalMobileUsers,
            totalWebUsers,
            totalUnknownUsers,
        });
    }

//  getChartOptions () {
//    const handleRegistraionCount = this.handleRegistraionCount;
//    return {
//      legend : {
//        onClick: function (index: MouseEvent , element: ChartLegendItem) {
//         handleRegistraionCount(element.text || '');
//         // override chart legend click
//         // defaults?.global?.legend?.onClick?.call(this, index, element);
//        }
//      }
//    };
//  }

    render() {
        return (
            <div>
                <div>
                    <UsersChartComponent/>
                    <div className={classes.datePickerContainer}>
                        <div>
                            <DatePicker
                                variant='inline'
                                format='MM/dd/yyyy'
                                label='From'
                                value={this.state.from}
                                onChange={(value) => {
                                    this.handleFromChanged(value);
                                }}
                            />
                            <DatePicker
                                variant='inline'
                                format='MM/dd/yyyy'
                                label='To'
                                value={this.state.to}
                                onChange={(value) => {
                                    this.handleToChanged(value);
                                }}
                            />
                        </div>
                        <div>
                            <Button onClick={this.clearFilter} color='primary' variant='contained'>Clear</Button>
                            <Button onClick={this.filter} color='primary' variant='contained'>Filter</Button>
                        </div>
                    </div>
                    <sub className={classes.footnote}>
                        * Default numbers below accounts for the past 12 months only.
                    </sub>
                </div>
                <div>
                    <h3>
                        <span>{translate('totalRgistred', {})} : </span>
                        <span>{this.state.totalRgistred}</span>
                    </h3>
                </div>
                <div className={classes.registrationContainer}>
                    <h4>
                        <span>{translate('totalMobileUsers', {})} : </span>
                        <span>{this.state.totalMobileUsers}</span>
                    </h4>
                    <h4>
                        <span>{translate('totalWebUsers', {})} : </span>
                        <span>{this.state.totalWebUsers}</span>
                    </h4>
                    <h4>
                        <span>{translate('totalSportsUsers', {})} : </span>
                        <span>{this.state.totalSportsUsers}</span>
                    </h4>
                    <h4>
                        <span>{translate('totalUnknownUsers', {})} : </span>
                        <span>{this.state.totalUnknownUsers}</span>
                    </h4>
                </div>
                {this.state.usersData && <Line
                    data={this.state.usersData}
                />}
            </div>
        );
    }
}

export default DetailedStatisticsScreen;
